import React from "react";
import Lottie from "lottie-react";

import * as animationData from '../../config/anim/loading.json'
import * as animationDataWhite from '../../config/anim/loading_white.json'

export default ({width, isWhite = false}) => {

    return <Lottie animationData={isWhite ? animationDataWhite : animationData} loop={true} autoplay={true} style={{width:width ?? "64px"}}  />
}
